export const ACHIEVEMENT_ICONS: Record<string, string> = {
  carrier_qualified: "⚓",
  night_qualified: "🌙",
  three_wire: "🎯",
  comeback_kid: "🔄",
  bolter_bolter: "💨",
  barely_recovered: "🤏",
  fleet_defender: "🛡️",
  textbook_trap: "📚",
  quick_tank: "⏱️",
  night_tanker: "🦯",
  transfer_complete: "⛽",
  special_delivery: "📦",
  so_high_right_now: "🛰️",
  i_feel_the_need: "⏩",
  speed_is_life: "🚀",
  ygbsm: "😱",
  slapshot: "🏒",
  sure_shot: "💫",
  winchester: "📭",
  tank_killer: "🔟",
  double_kill: "✌",
  avenger: "⚔️",
  gunship: "🚁",
  death_from_below: "🏹",
  nap_of_the_earth: "🌿",
  five_hundred_miles: "🧭",
  perfect_contact: "🔗",
  fox_four: "🦊",
  shooting_star: "🌠",
  one_pass_haul_ass: "↩",
  wheels_up: "🛫",
  home_base: "🏠",
  splash_one: "💧",
  shack: "🎯",
  night_stalker: "🦇",
  instant_ace: "♠️",
  air_wolf: "🐺",
  drop_shot: "💣",
  unicorn_shot: "🦄",
  there_and_back_again: "🗺️",
};

export const DEFAULT_ACHIEVEMENT_ICON = "🏅";
